import React from 'react';
import Box from '@mui/material/Box';

export function CircularImageAndTextBox({
  imgSrc,
  backgroundColor = '#6c8cb5',
  children,
}) {
  return (
    <Box
      sx={{
        position: 'relative',
        borderRadius: '8px',
        background: `${backgroundColor}`,
        padding: '22.5px 30px 22.5px 67.5px',
        color: '#ffffff',
        fontFamily: 'Whitney Light',
        fontWeight: 600,
        fontSize: '1.375rem',
        lineHeight: '1.5625rem',
        /*
          Material UI's Stack component's spacing prop resets its children component's
          margin to 0 then sets either a top margin (when direction is column) or a
          left margin (when direction is row) to implement the spacing
        */
        '&&': {
          marginLeft: '60px',
        },
        '&::before': {
          content: '""',
          background: `#ffffff url(${imgSrc}) center center no-repeat`,
          display: 'block',
          width: '90px',
          height: '90px',
          position: 'absolute',
          left: '-50px',
          top: '-9px',
          border: `4px solid ${backgroundColor}`,
          borderRadius: '50%',
          backgroundSize: '60px',
          zIndex: 60,
        },
        '&::after': {
          content: '""',
          display: 'block',
          width: '110px',
          height: '110px',
          position: 'absolute',
          left: '-60px',
          top: '-19px',
          border: '3px solid #6c8cb5',
          borderRadius: '50%',
          background: '#ffffff',
          zIndex: 50,
        },
      }}
    >
      {children}
    </Box>
  );
}
